// CAPEVRCitation.jsx

import { useTranslation } from 'react-i18next';
import CitationLabel from './CitationLabel';

function CAPEVRCitation({ modificationNote = null }) {
  const { t } = useTranslation();

  return (
    <div >
      <div>
        <CitationLabel>
          {t('original_instrument', 'Original instrument')}
        </CitationLabel>
        Kempster, G. B., Nagle, K. F., & Solomon, N. P. (2025). Development and rationale for the Consensus Auditory-Perceptual Evaluation of Voice – Revised (CAPE-Vr). <em>Journal of Voice</em>. <a href="https://doi.org/10.1016/j.jvoice.2025.01.022" target="_blank" rel="noopener noreferrer">https://doi.org/10.1016/j.jvoice.2025.01.022</a>. {t('creative_commons_license_notice')} <a href="https://creativecommons.org/licenses/by/4.0/" target="_blank" rel="noopener noreferrer">https://creativecommons.org/licenses/by/4.0/</a>.
        <em> {modificationNote ? modificationNote : t('no_modifications_made')}</em>
        <br /><br />
      </div>
    </div>
  );
}

export default CAPEVRCitation;
